import React, { useCallback } from "react"
import * as Components from "../components/components"
import { EventBus } from "../eventbus"
import { useTranslation } from "react-i18next"
import { useStoreRechnung } from "../store"

interface KontaktdatenViewProps {
    basePath: string
}

export function RechnungsstellerKontaktdatenView({ basePath }: KontaktdatenViewProps) {
    const { t } = useTranslation()
    const { rechnungssteller } = useStoreRechnung("rechnungssteller")

    const kontaktdaten = rechnungssteller.rechnungssteller.kontaktdaten
    const onChange = useCallback<(element: string) => (value: unknown) => void>(
        (path: string) => (value: unknown) => {
            EventBus.instance.emit("changeProperty", `${basePath}.${path}`, value)
        },
        [basePath],
    )

    return (
        <Components.Collapsible title={t("rechnung.rechnungssteller.kontaktdaten.title")} collapsed={false}>
            <Components.FormGroup label={t("rechnung.rechnungssteller.kontaktdaten.name.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungssteller.kontaktdaten.name.placeholder")}
                    onChange={onChange("name")}
                    value={kontaktdaten.name}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungssteller.kontaktdaten.telefon.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungssteller.kontaktdaten.telefon.placeholder")}
                    onChange={onChange("telefon")}
                    value={kontaktdaten.telefon}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungssteller.kontaktdaten.email.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungssteller.kontaktdaten.email.placeholder")}
                    onChange={onChange("email")}
                    value={kontaktdaten.email}
                />
            </Components.FormGroup>
        </Components.Collapsible>
    )
}
